import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../Store';

export const customizerProvince = (state: AppState) => state.customizer;

export const customizerSelector = createSelector(customizerProvince, (state) => state);
